import React from "react";
import { MessageCircle, X, Heart } from "lucide-react";

/**
 * ShareRoniNudge
 * ---------------------------------------------------------------
 * Injected into the chat stream once a visitor has asked ~6 questions.
 * Encourages sharing Roni to friends via WhatsApp. If the visitor
 * types another message instead of tapping Share, the widget removes
 * this nudge from the stream so it doesn't clutter the scrollback.
 */
export default function ShareRoniNudge({ lang = "en", onDismiss }) {
  const isAr = lang === "ar";
  const shareUrl = "https://thepropertic.ae/aiagent";
  const messageEn = `Hey, try Roni, an AI Dubai real-estate advisor with live DLD data. Ask him anything about the market: ${shareUrl}`;
  const messageAr = `جرّب روني, مستشار عقاري ذكي في دبي يعمل ببيانات دائرة الأراضي الحيّة. اسأله أي شيء عن السوق: ${shareUrl}`;
  const text = isAr ? messageAr : messageEn;
  const waHref = `https://wa.me/?text=${encodeURIComponent(text)}`;

  return (
    <div
      className="relative bg-gradient-to-br from-propertic-gold-2/25 to-propertic-gold/15 border border-propertic-gold/40 rounded-2xl p-4 shadow-sm"
      data-testid="roni-share-nudge"
    >
      <button
        onClick={onDismiss}
        aria-label={isAr ? "إغلاق" : "Dismiss"}
        data-testid="roni-share-dismiss"
        className="absolute top-2 end-2 w-7 h-7 grid place-items-center rounded-full text-propertic-muted hover:text-propertic-navy hover:bg-propertic-paper/60 transition"
      >
        <X className="w-3.5 h-3.5" />
      </button>
      <div className="flex items-start gap-3 pe-6">
        <div className="w-9 h-9 rounded-full bg-propertic-gold/20 grid place-items-center shrink-0">
          <Heart className="w-4 h-4 text-propertic-gold fill-propertic-gold/40" />
        </div>
        <div className="min-w-0">
          <p className="font-mono-brand text-[10px] tracking-[0.2em] uppercase text-propertic-gold mb-1">
            {isAr ? "شارك روني" : "Loving Roni?"}
          </p>
          <p className="text-[13px] text-propertic-navy font-editorial leading-snug">
            {isAr
              ? "شارك روني مع صديق يبحث عن عقار في دبي؛ المشاركة سريعة وبسيطة."
              : "Share Roni with a friend house-hunting in Dubai, takes 10 seconds."}
          </p>
        </div>
      </div>
      <a
        href={waHref}
        target="_blank"
        rel="noreferrer"
        data-testid="roni-share-whatsapp"
        onClick={() => setTimeout(onDismiss, 300)}
        className="mt-3 w-full h-10 rounded-full bg-[#25D366] hover:bg-[#1EBE5B] text-white font-mono-brand text-[11px] tracking-[0.2em] uppercase inline-flex items-center justify-center gap-2 transition-colors"
      >
        <MessageCircle className="w-3.5 h-3.5" />
        {isAr ? "شارك على واتساب" : "Share on WhatsApp"}
      </a>
    </div>
  );
}
